import { getHttp } from '@/api/httpFactory';
import { APPSTORE_URLS } from './urls';

const http = getHttp(import.meta.env.VITE_API_APPSTORE_URL, true);

const developerApi = {
    /**
     * Get all tests stores createds
     * @returns Array of test stores
     */
    async getEnvironments() {
        const response = await http.get(APPSTORE_URLS.ENVIRONMENT.LIST);

        if (response?.data?.data) {
            return response.data.data;
        } else {
            throw new Error('Invalid response');
        }
    },

    /**
     * Get data from the logged user/developer
     * @returns
     */
    async fetchMe() {
        const response = await http.get(APPSTORE_URLS.AUTH.ME);

        if (response?.data?.data) {
            return response.data.data;
        } else {
            throw new Error('Invalid response');
        }
    },
};

export default developerApi;
